export default __webpack_public_path__ + "files/media/hd.71e6c7d1.jpg";